import {
  ArrowLeftRight, ArrowLeftToLine, ArrowRightToLine, ArrowUpDown, ArrowUpToLine,
  BarChart3, Binary, Blend, Calculator, Calendar, CaseSensitive, CircleSlash,
  CirclePlus, Cloud, Columns2, Columns3, Combine, Coins, CopyMinus, Crop,
  Delete, Eraser, Expand, FileInput, FileSpreadsheet, FileText, Filter,
  Fingerprint, FunctionSquare, GitBranch, Globe, Hash, Layers, Map, MapPin,
  MoveHorizontal, PenLine, Regex, Replace, Ruler, RotateCw, Scale, Scissors,
  Search, SeparatorVertical, Settings2, ShieldAlert, ShieldCheck,
  SlidersHorizontal, Smile, Sparkles, SquareCheck, SquareMinus, SquareStack,
  Sigma, Split, Tag, Target, Type, TrendingDown, TrendingUp, Upload, Wand2,
  Zap, Dices, Rows3, Shuffle, Send, Circle,
} from 'lucide-react';

// Step-type/category icon registry — one lucide-react component per `icon`
// key used in data.js's CATEGORIES/STEP_TYPES (was raw emoji glyphs before
// the icon migration; each entry named explicitly, not `import * as`, so
// unused icons still tree-shake out of the bundle).
const ICONS = {
  ArrowLeftRight, ArrowLeftToLine, ArrowRightToLine, ArrowUpDown, ArrowUpToLine,
  BarChart3, Binary, Blend, Calculator, Calendar, CaseSensitive, CircleSlash,
  CirclePlus, Cloud, Columns2, Columns3, Combine, Coins, CopyMinus, Crop,
  Delete, Eraser, Expand, FileInput, FileSpreadsheet, FileText, Filter,
  Fingerprint, FunctionSquare, GitBranch, Globe, Hash, Layers, Map, MapPin,
  MoveHorizontal, PenLine, Regex, Replace, Ruler, RotateCw, Scale, Scissors,
  Search, SeparatorVertical, Settings2, ShieldAlert, ShieldCheck,
  SlidersHorizontal, Smile, Sparkles, SquareCheck, SquareMinus, SquareStack,
  Sigma, Split, Tag, Target, Type, TrendingDown, TrendingUp, Upload, Wand2,
  Zap, Dices, Rows3, Shuffle, Send,
};

// Renders the lucide icon named by `name` (a key into ICONS, e.g. `meta.icon`
// from CATEGORIES/STEP_TYPES) — falls back to a plain circle for an unknown/
// missing key rather than rendering nothing.
export function StepIcon({ name, size = 16, style, ...rest }) {
  const Icon = ICONS[name] || Circle;
  return <Icon size={size} style={style} {...rest} />;
}
